module.exports = __webpack_public_path__ + "img/4@2x.e84caba4.webp";